export enum SnackBarTypes {
  error = 'error',
  success = 'success'
}
